import { render, staticRenderFns } from "./designer-table.vue?vue&type=template&id=a5fb5b72&scoped=true"
import script from "./designer-table.vue?vue&type=script&lang=js"
export * from "./designer-table.vue?vue&type=script&lang=js"
import style0 from "./designer-table.vue?vue&type=style&index=0&id=a5fb5b72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fb5b72",
  null
  
)

export default component.exports